import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push, goBack } from 'react-router-redux';

import { clearErrors } from './../../../user/userActions';

import Image from '../../../../containers/UI/Image/Image';
import Zigzag from './../../../../containers/UI/Common/Shapes/Zigzag';
import EditUserForm from './../../../forms/editUserForm';
import ClickableIcon from './../../../../containers/UI/ClickableIcon/ClickableIcon';
import MessageModal from './../../../../containers/UI/MessageModal/MessageModal';

//-- Utils
import { pushPageView } from '../../../../utils/tracking/customGtm';
import { pushHeaderTitle } from '../../../../utils/dom/helper';

// Assets
import MonstreImg from '../../../../assets/images/kiddy.svg';

class EditProfile extends Component {

    componentDidMount() {
        //-- Update title
        pushHeaderTitle('Edition du profile');

        //-- Push GTM page view
        pushPageView();
    }

    closeProfileHandler = () => {
        if(this.props.isSubscriber){
            this.props.redirect('/account/profile');
        }else {
            this.props.redirect('/'); // force to redirect to "index" page 
        }
    }

    closeModalHandler = () => {
        
        this.props.onClearErrors();
    }

    render() {
        const { user } = this.props;
        return <div className="edit-account-page">
                    <MessageModal 
                        show={user.hasError}
                        closeModalHandler={this.closeModalHandler}
                        image="error"
                        class="edit-profile"
                        message= {user.errorMessage}
                        zigzagColor="#49d1e5"
                        zigzagClass="blue-shape"
                    />
                    <ClickableIcon name="close-profile" class="" action={this.closeProfileHandler} />
                    <div className="yellow-shape">    
                        <Zigzag color="#ffde39" />
                    </div>
                    <div className="blue-shape">    
                        <Zigzag color="#49d1e5" translateXaxis="10"/>
                    </div>
                    <h2>Je modifie mon <span className="no-wrap">super profil</span></h2>
                    <div className="account-character-profile">
                        <Image 
                            isResponsive='true'
                            imgPath={MonstreImg}
                            imgName="account-character"
                        />   
                    </div>
                    <EditUserForm />
                </div>
    }
}

const mapStateToProps = state => {
    return {
        user: state.user,
        isSubscriber : state.auth.isSubscriber
    }
};

const mapDispatchToProps = dispatch => {
    return {
        redirect: ( path ) => dispatch(push(path)),
        onClearErrors: () => dispatch(clearErrors())
    };
};

export default connect( mapStateToProps, mapDispatchToProps )(EditProfile);


// WEBPACK FOOTER //
// ./src/components/Account/Profile/Edit/EditProfile.js